import type { Meta, StoryObj } from "@storybook/react";

import type { OnboardingIconContainerProps } from "@/ui/components/onboarding/OnboardingIconContainer";
import OnboardingIconContainer from "@/ui/components/onboarding/OnboardingIconContainer";
import { FAIconName } from "@/ui/core";

const StoryMeta: Meta<OnboardingIconContainerProps> = {
  title: "Components/Onboarding/Onboarding Icon Container",
  component: OnboardingIconContainer,
  argTypes: {
    iconName: {
      control: "select",
      options: Object.values(FAIconName),
    },
  },
  args: {
    iconName: FAIconName.UserDoctor,
  },
};

type Story = StoryObj<OnboardingIconContainerProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
